<template>
  <div class="analysis-chart-wrap" v-loading="loading">
    <div v-if="thisValData.length >0" class="grid">
      <div class="item" v-for="(item,index) in thisValData" :key="index">
        <div>{{item.displayName}}</div>
        <div class="val">
          {{item.value}}{{item.unit}}
        </div>
      </div>
    </div>
    <div id="echarts-box"></div>
    <div class="item-box table-box box">
      <nk-table :data="maxMinTable" :columns="columns" :border="false"></nk-table>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
import NkTable from "@/components/common/NkTable.vue";
import DateTool from "@/utils/dateTool.js";
export default {
  props: ["selectedTab", "measureName"],
  components: { NkTable },
  data () {
    return {
      loading: false,
      rawData: "",
      columns: [],
      maxMinTable: [],
      thisValData: []
    };
  },
  created () { },
  computed: {},
  mounted () { },
  beforeDestroy () { },
  methods: {
    /**
     * 保留两位小数
     */
    reserveTwoDecimalPlaces (val) {
      if (typeof val == 'undefined' || val == null) {
        return '-'
      }
      else {
        return Number(val).toFixed(2)
      }
    },
    getData (_rawData, thisVal, list, pattern, xData) {
      console.log(_rawData)
      let vm = this;
      let thisValData = []
      for (let key in thisVal) {
        const expForVal = list.expData.find(
          c => c.pointCode + '_' + c.pointNumber == key
        )
        thisValData.push({ displayName: expForVal.displayName, value: vm.reserveTwoDecimalPlaces(thisVal[key]), unit: expForVal.unit })
      }
      vm.thisValData = thisValData
      let xAxisData = [];
      let seriesData = {};
      let seriesDatas = [];
      let index = 0;
      let legend = [];
      this.maxMinTable = [];

      if (pattern) {
        for (let i = 0; i < xData.length; i++) {
          // const element = array[i];
          xAxisData.push(DateTool.format(xData[i], pattern));
        }
      }
      for (let key in _rawData) {
        index++;
        seriesData[index] = [];
        const exp = list.expData.find(
          c =>
            c.pointCode == key.split("_")[0] &&
            c.pointNumber == key.split("_")[1]
        )
        legend.push(
          exp.displayName + (exp.unit.length > 0 ? `(${exp.unit})` : '')
        );
        let obj = {
          type: "line",
          name: exp.displayName + (exp.unit.length > 0 ? `(${exp.unit})` : ''),
          showSymbol: false,
          data: ""
        };
        let tableObj = {
          measureName: this.measureName,
          codeLabel: exp.displayName + (exp.unit.length > 0 ? `(${exp.unit})` : ''),
          max: "",
          maxTime: "",
          min: "",
          minTime: ""
        };

        if (pattern) {
          seriesData[index] = []
          for (let i = 0; i < xData.length; i++) {
            const time = xData[i];
            const dataForTime = _rawData[key].find(c => new Date(c.time).getTime() == time.getTime())
            if (dataForTime) {
              if (tableObj.max == '' || (dataForTime.value - tableObj.max) > 0) {
                tableObj.max = dataForTime.value
                tableObj.maxTime = dataForTime.time
              }
              if (tableObj.min == '' || (tableObj.max - dataForTime.value) > 0) {
                tableObj.min = dataForTime.value
                tableObj.minTime = dataForTime.time
              }
              seriesData[index].push(vm.reserveTwoDecimalPlaces(dataForTime.value))
            } else {
              seriesData[index].push('-')
            }
          }
        }
        else {
          _rawData[key].forEach((item, i) => {
            xAxisData.push(item.time)
            if (tableObj.max === '' || (item.value - tableObj.max) > 0) {
              tableObj.max = item.value
              tableObj.maxTime = item.time
            }
            if (tableObj.min === '' || (tableObj.max - item.value) > 0) {
              tableObj.min = item.value
              tableObj.minTime = item.time
            }
            seriesData[index].push(vm.reserveTwoDecimalPlaces(item.value));
          });
        }

        tableObj.min = tableObj.min === "" ? '-' : tableObj.min
        tableObj.minTime = tableObj.minTime === "" ? '-' : tableObj.minTime
        tableObj.max = tableObj.max === "" ? '-' : tableObj.max
        tableObj.maxTime = tableObj.maxTime === "" ? '-' : tableObj.maxTime

        vm.maxMinTable.push(tableObj);
        obj.data = seriesData[index];
        seriesDatas.push(obj);
      }

      this.rawData = _rawData;
      let myChartDom = document.getElementById("echarts-box");
      let myChart = echarts.init(myChartDom);
      let option = {
        dataset: [
          {
            id: "dataset_raw",
            source: _rawData
          },
          {
            id: "dataset_since_1950_of_germany",
            fromDatasetId: "dataset_raw",
            transform: {
              type: "filter",
              config: {
                and: [
                  { dimension: "Year", gte: 1950 },
                  { dimension: "Country", "=": "Germany" }
                ]
              }
            }
          },
          {
            id: "dataset_since_1950_of_france",
            fromDatasetId: "dataset_raw",
            transform: {
              type: "filter",
              config: {
                and: [
                  { dimension: "Year", gte: 1950 },
                  { dimension: "Country", "=": "France" }
                ]
              }
            }
          }
        ],
        dataZoom: [
          {
            type: "inside",
            start: 0,
            end: 100
          },
          {
            start: 0,
            end: 100
          }
        ],
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: legend
        },
        xAxis: {
          type: "category",
          nameLocation: "middle",
          data: xAxisData
        },
        yAxis: {
        },

        series: seriesDatas
      };

      var option1 = {};
      option1 = Object.assign(option1, option);
      myChart.setOption(option1, true);

      vm.columns = [
        { prop: "measureName", label: "测量点名称", show: true },
        { prop: "codeLabel", width: 240, label: "采集类型", show: true },
        {
          prop: "max",
          label: "最大" + list.displayName,
          align: "right",
          show: true
        },
        {
          prop: "maxTime",
          label: "最大" + list.displayName + "发生时间",
          show: true
        },
        {
          prop: "min",
          label: "最小" + list.displayName,
          align: "right",
          show: true
        },
        {
          prop: "minTime",
          label: "最小" + list.displayName + "发生时间",
          show: true
        }
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
.analysis-chart-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;
}
.tab-small {
  width: 100%;
  height: 30px;
  text-align: left;
  display: flex;
  align-items: center;
}
.tab-small .el-radio-group {
  flex: 1;
}
.tab-small .el-icon-circle-close {
  padding: 0px 10px;
  font-size: 20px;
  cursor: pointer;
}
.table-div {
  width: 100%;
  height: calc(100% - 30px);
}
.table-box {
  margin-top: 14px;
  height: 180px;
}
.checkbox {
  width: 33.3%;
  padding-bottom: 6px;
}
.grid {
  width: 100%;
  margin-bottom: 14px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  .item {
    padding: 14px;
    text-align: center;
    background: #fff;
    margin-right: 7px;
    margin-left: 7px;
    .val {
      font-size: 28px;
      font-weight: bold;
      line-height: 50px;
    }
  }
}
</style>

<style lang="scss" scoped>
.data-list {
  background: #fff;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 4px;
  padding: 0px 10px 10px 10px;
}
.data-item {
  display: flex;
  flex-flow: column;
  width: calc(25% - 12px);
  margin-right: 12px;
  float: left;

  background: #0097ee;
  border-radius: 4px;
  padding: 10px;
  box-sizing: border-box;
  margin-top: 10px;

  .value {
    text-align: center;
    font-size: 30px;
    font-weight: bold;
    color: #ffffff;
  }
  .title {
    text-align: center;
    color: #d8d8d8;
  }
}
.data-item:nth-child(4n) {
  margin-right: 0px;
}
.title-box {
  margin-top: 14px;
  padding: 10px;
}
#echarts-box {
  width: 100%;
  border-radius: 4px;
  height: 400px;
  background: #fff;
}
</style>
